import { Address } from 'viem';

import { api, cacheTags } from 'modules/api';
import { getPublicClient } from 'modules/api/getPublicClient';
import {
  getFlashUnstakeData,
  IGetFlashUnstakeDataResult,
} from 'modules/liquidStaking/methods/getFlashUnstakeData';

interface IGetFlashUnstakeDataArgs {
  poolAddress?: Address;
}

export const { useGetFlashUnstakeDataQuery } = api.injectEndpoints({
  endpoints: build => ({
    getFlashUnstakeData: build.query<
      IGetFlashUnstakeDataResult,
      IGetFlashUnstakeDataArgs | void
    >({
      queryFn: async params => {
        const client = getPublicClient();
        const { poolAddress } = params || {};

        return { data: await getFlashUnstakeData(client, poolAddress) };
      },
      providesTags: [cacheTags.liquidStaking],
    }),
  }),
});
